import { render } from "./loadingScreen.vue?vue&type=template&id=16ecdcd3&scoped=true"
import script from "./loadingScreen.vue?vue&type=script&lang=js"
export * from "./loadingScreen.vue?vue&type=script&lang=js"

import "./loadingScreen.vue?vue&type=style&index=0&id=16ecdcd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ecdcd3"]])

export default __exports__